import React, { Component } from 'react';

import APIDocsCurl from 'common/developers/docs/api/APIDocsCurl';
import APIDocsMethod from 'common/developers/docs/api/APIDocsMethod';
import Highlight from 'common/developers/docs/api/Highlight';

import APIDocsBlock from '../APIDocsBlock';
import APIDocsTable from '../APIDocsTable';

export default class APIDocsListVotesBlock extends Component {
  createdAt = new Date();

  render() {
    return (
      <APIDocsBlock>
        <div>
          <div className="heading">List votes</div>
          <div className="text">
            Returns a list of votes. Include parameters to specify post, board, and&nbsp;pagination.
            Sorted by newest.
          </div>
          <APIDocsTable
            title="Arguments"
            rows={[
              {
                description: 'Your secret API key.',
                heading: 'apiKey',
                subheading: 'string',
              },
              {
                description: "The id of the board you'd like to fetch votes for.",
                heading: 'boardID',
                subheading: 'string (optional)',
              },
              {
                heading: 'companyID',
                subheading: 'string (optional)',
                description:
                  'If specified, will only fetch votes created by users linked to the company with this custom identifier.',
              },
              {
                description:
                  'A pagination cursor returned from a previous request. Used to fetch the next page of results.',
                heading: 'cursor',
                subheading: 'string (optional)',
              },
              {
                description:
                  "The number of votes you'd like to fetch. Must be between 1 and 100. Defaults to 10 if not specified.",
                heading: 'limit',
                subheading: 'number (optional)',
              },
              {
                description: 'Specify a postID to only fetch votes for a specific post.',
                heading: 'postID',
                subheading: 'string (optional)',
              },
              {
                description: 'Specify a userID to only fetch votes for a specific user.',
                heading: 'userID',
                subheading: 'string (optional)',
              },
            ]}
          />
          <div className="subheading">Returns</div>
          <div className="text">
            A dictionary with an "items" property that contains an array of vote objects. There's
            also a "hasNextPage" property that specifies whether there are more votes available, and
            a "cursor" property that can be used to fetch the next page of results.
          </div>
        </div>
        <div>
          <div className="text">Endpoint</div>
          <Highlight lang="http">https://canny.io/api/v2/votes/list</Highlight>
          <APIDocsMethod />
          <APIDocsCurl
            path="https://canny.io/api/v2/votes/list"
            body={`\\
    -d apiKey=YOUR_API_KEY \\
    -d postID=553c3ef8b8cdcd1501ba2468`}
          />
          <div className="text">Example Response</div>
          <Highlight lang="json">
            {`{
  "cursor": "eyJhZnRlciI6eyJfaWQiOiI1NTNjM2VmOGI4Y2RjZD...",
  "hasNextPage": true,
  "items": [{
    "id": "553c3ef8b8cdcd1501ba123b",
    "board": {
      "created": "${this.createdAt.toISOString()}",
      "id": "553c3ef8b8cdcd1501ba1234",
      "name": "Feature Requests",
      "postCount": 123,
      "url": "https://your-company.canny.io/admin/board/feature-requests"
    },
    "by": null,
    "created": "${this.createdAt.toISOString()}",
    "post": {
      "category": {
        "id": "553c3ef8b8cdcd1501ba2234",
        "name": "Dashboard",
        "postCount": 42,
        "url": "https://your-company.canny.io/admin/board/feature-requests?category=dashboard"
      },
      "commentCount": 2,
      "id": "553c3ef8b8cdcd1501ba4444",
      "imageURLs": [],
      "jira": {
        "linkedIssues": [{
          "id": "123",
          "key": "ID-123",
          "url": "https://your-company.atlassian.net/browse/ID-123"
        }],
      },
      "linear": {
        "linkedIssueIDs": ["ID-123", "ID-345"]
      },
      "score": 13,
      "status": "planned",
      "tags": [{
        "id": "553c3ef8b8cdcd1501ba3234",
        "name": "iOS",
        "postCount": 15,
        "url": "https://your-company.canny.io/admin/board/feature-requests?tags=ios"
      }],
      "title": "post-title",
      "url": "https://your-company.canny.io/admin/board/feature-requests/p/post-title"
    },
    "voter": {
      "id": "553c3ef8b8cdcd1501ba123a",
      "created": "${this.createdAt.toISOString()}",
      "email": "test@test.test",
      "isAdmin": false,
      "name": "Sally Doe",
      "url": "https://your-company.canny.io/admin/users/sally-doe",
      "userID": "1234"
    },
    "votePriority": "No priority",
    "zendeskTicket": {
      "id": "2",
      "created": "2018-12-14T19:20:25Z",
      "subject": "Ticket subject",
      "description": "Ticket description",
      "url": "https://your-company.zendesk.com/api/v2/tickets/2.json"
    }
  }]
}`}
          </Highlight>
        </div>
      </APIDocsBlock>
    );
  }
}
